module.exports = __webpack_public_path__ + "static/media/Promos_20_.8f27768a.png";